import styled from 'styled-components';

import {
  colorBlack900,
  colorBorder,
  colorGrey200,
  colorGrey400,
  colorPrimary400,
  colorWhite,
  fontFamilyPrimary,
} from '@/styleUtils';

export const Wrapper = styled.div`
  display: inline-flex;
  position: relative;
  width: 100%;
  height: 48px;
`;

export const Placeholder = styled.span`
  background-color: ${colorWhite};
  color: ${colorGrey400};
  font: 400 16px/100% ${fontFamilyPrimary};
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  transform: translate(12px, 16px);
  transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  z-index: 1;
`;

export const ToggleBtn = styled.button`
  background-color: transparent;
  box-shadow: inset 0 0 0 1px ${colorGrey200};
  border-radius: 4px;
  font: 400 16px/28px ${fontFamilyPrimary};
  color: ${colorGrey400};
  font-size: 16px;
  line-height: 16px;
  outline: none;
  padding: 10px 62px 10px 12px;
  position: relative;
  white-space: nowrap;
  text-align: left;
  width: 100%;
  transition: 0.2s;

  &::after {
    content: '';
    position: absolute;
    right: 18px;
    top: 22px;
    width: 0;
    height: 0;
    border-left: 5.5px solid transparent;
    border-right: 5.5px solid transparent;
    border-top: 5px solid ${colorBlack900};
  }

  &[data-empty='false'] {
    & ${Placeholder} {
      padding: 0 4px;
      transform: translate(2px, -8px) scale(0.75);
      letter-spacing: 0.36px;
    }
  }

  &[data-active='true'] {
    &::after {
      transform: rotate(-180deg);
    }
  }

  &:hover,
  &:active,
  &[data-active='true'] {
    box-shadow: inset 0 0 0 2px ${colorPrimary400};
    & ${Placeholder} {
      color: ${colorPrimary400};
    }
  }
`;

export const ToggleBtnLabel = styled.span`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  color: ${colorBlack900};
`;

export const PlaceholderMoreText = styled.span`
  white-space: nowrap;
`;

export const Options = styled.div`
  background-color: ${colorWhite};
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.24);
  border-radius: 4px;
  left: 0;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: 2;
`;

export const OptionsList = styled.div`
  max-height: 312px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    max-height: 50px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${colorWhite};
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 0 16px;
  border: 1px solid ${colorBorder};

  svg {
    height: 16px;
    width: 16px;
    flex-shrink: 0;
    color: ${colorGrey200};
  }
`;

export const InputStyles = styled.input`
  width: 100%;
  height: 48px;
  border: none;
  padding: 0;
  box-shadow: none;
  outline: none;
  font: 400 16px/100% ${fontFamilyPrimary};
`;

export const ClearWrapper = styled.div`
  margin-left: 6px;
  cursor: pointer;
  display: none;

  svg {
    margin: 0;
    height: 14px;
    width: 14px;
  }

  &[data-has-search='true'] {
    display: block;
  }
`;

export const ClearValuesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 36px;
  top: 12px;
  width: 24px;
  height: 24px;
  color: ${colorGrey400};

  svg {
    height: 14px;
    width: 14px;
  }
`;

export const IconsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;
